import React, {useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import './hero.scss';

// TODO: re-enable carousel

function Hero(page) {
  const imgPath = "";
  //props fetch data from hero.json
  // const brand = process.env.REACT_APP_BRAND_NAME;
  const siteConfig = page.page
  // Make conditional if local file or API
  // const imgPath = '/images/' + siteConfig.siteName + '/' + siteConfig.brandName + '/';
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;
  
  // const gardenBG = siteConfig.hero.garden[0].background.hasBG === 'true' ? imgPath + siteConfig.hero.garden[0].background.image : '';
  // const gardenStyle = {
  //   backgroundImage: "url(" + gardenBG + ")"
  // };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  //switch to hero mobile image if screen is less than 768px width

  function StaticHero(){
    const hero = siteConfig.components.find(component => component.block_type === 'HeaderBlock').header_set[0];
    // const imgPath = process.env.REACT_APP_BACKEND + (!isMobile ? siteConfig.header_set[0].header_image : siteConfig.header_image_mobile)
    return (
      <img
        className="heroImg"
        src={isMobile ? hero.header_image_mobile : hero.header_image}
        alt={hero.header_image_alt_text}
      />
    );
  }
  function HeroCarousel() {
    
    const hero = siteConfig.components.find(component => component.block_type === 'HeaderBlock').header_set[0];
    const heroCarousel = siteConfig.components.find(component => component.block_type === 'HeaderBlock').header_set;
    console.log(hero)
    return (
      <Carousel
        autoPlay={true}
        interval={5000}
        infiniteLoop={true}
        showStatus={false}
        showArrows={false}
        showThumbs={false}
        showIndicators={false}
        swipeable={true}
        onClickItem={anchorItem}
      >
        {heroCarousel.map((item, i) => {
          return(
            <a href={item.anchor} key={i}>
              <img
                className={`heroImg`}
                src={item.header_image}
                alt={item.header_image_alt_text}
              />
            </a>
          )
        })}
      </Carousel>
    );
  }
  function anchorItem(i,child){
    if(child.props.href){
      window.location.href = child.props.href;
    }
  }

  const hero = siteConfig.components.find(component => component.block_type === 'HeaderBlock');
  return (
    
    <div className='header'>
      <div className="hero">
        { hero.header_set.length > 1 && <HeroCarousel/> }
        { hero.header_set.length == 1 && <StaticHero/> }
      </div>
    </div>
  );
}
export default Hero;
